import React from "react";

import { Button, Row, Layout, Modal } from "antd";
import Graph from "./Graph";
import NumberFilter from "./NumberFilter";
import Filter from "./Filter";
import InputFilter from "./InputFilter";
import axios from "axios";

import { partial } from "lodash";

const { Content, Sider } = Layout;

export default function BiddingProvidersGraph(props) {
  const [filters, setFilters] = React.useState({
    coherence: [80],
    exclusivity: [80],
  });
  const [renderFlag, setRenderFlag] = React.useState(false);
  const [modalProps, setModalProps] = React.useState({
    visible: false,
    title: "Cooeferentes",
    tenders: [],
  });

  const api = `${props.url}/cobidders_graph`;

  function onFilterChange(key, values) {
    let result = { ...filters };
    result[key] = [].concat(values);
    setFilters(result);
  }

  function onRender() {
    setRenderFlag(!renderFlag);
  }

  function onLinkClick(l, e) {
    const title = `${l.source.id} - ${l.target.id}`;
    const query = Object.keys(filters)
      .filter((k) => filters[k].some((v) => v))
      .flatMap((k) => filters[k].map((v) => `${k}=${v}`))
      .join("&");
    axios
      .get(
        `${props.url}/cobidding_tenders?bidder=${l.source.id}&bidder=${l.target.id}&${query}`
      )
      .then((response) => {
        setModalProps({
          ...modalProps,
          visible: true,
          title: title,
          tenders: response.data,
        });
      });
  }

  return (
    <Layout>
      <Sider width={250}>
        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Año desde"
            api={api}
            source="years"
            mode="single"
            onChange={partial(onFilterChange, "from_")}
          ></Filter>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <NumberFilter
            min={1}
            max={100}
            defaultValue={1}
            title={"Min. peso"}
            onChange={partial(onFilterChange, "min_weight")}
            info={"Permite seleccionar el número mínimo de interacciones que tuvieron los oferentes."}
          ></NumberFilter>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <NumberFilter
            min={0}
            max={100}
            defaultValue={80}
            title={"Coherencia"}
            onChange={partial(onFilterChange, "coherence")}
            info={"Es el ratio entre la media geométrica y la media aritmética del número de interacciones. Su función es capturar la consistencia y la intensidad de las interacciones de los oferentes agrupados."}
          ></NumberFilter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <NumberFilter
            min={0}
            max={100}
            defaultValue={80}
            title={"Exclusividad"}
            onChange={partial(onFilterChange, "exclusivity")}
            info={"Cuantifica la medida en que la interacción del grupo ocurre de manera aislada del resto de los oferentes del mercado."}
          ></NumberFilter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Entidad"
            api={api}
            source="entities"
            onChange={partial(onFilterChange, "entity")}
          ></Filter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Modalidad"
            api={api}
            source="procurement_types"
            onChange={partial(onFilterChange, "procurement_type")}
          ></Filter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Categoría"
            api={api}
            source="categories"
            onChange={partial(onFilterChange, "category")}
          ></Filter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Objeto de Llamado"
            api={api}
            source="procurement_objects"
            onChange={partial(onFilterChange, "procurement_object")}
          ></Filter>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <InputFilter
            placeholder="RUC (sin DV)"
            onChange={partial(onFilterChange, "ruc")}
          ></InputFilter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Button type="primary" style={{ width: "90%" }} onClick={onRender}>
            Dibujar
          </Button>
        </Row>
      </Sider>
      <Content>
        <Graph
          api={api}
          filters={filters}
          show={renderFlag}
          onRender={onRender}
          onLinkClick={onLinkClick}
        ></Graph>
        <Modal
          title={modalProps.title}
          visible={modalProps.visible}
          onCancel={() => setModalProps({ ...modalProps, visible: false })}
          footer={null}
        >
          {modalProps.tenders.map((t) => (
            <p key={t}>{t}</p>
          ))}
        </Modal>
      </Content>
    </Layout>
  );
}
